var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-select',{attrs:{"items":_vm.values,"multiple":"","item-text":"value","item-value":"key","menu-props":{ maxHeight: '400' },"label":_vm.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_vm._v("\n  "+_vm._s(_vm.description)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }